module.exports = __webpack_public_path__ + "assets/img/marriage-bg2.b68d3d4c.png";